import React from 'react'
import {useParams} from 'react-router'
import {useStores} from '../../../store'
import {DetailsPageHeader, ErrorComponent, FullLoader} from '../../common'
import {i18n}  from '../../../i18n'
import {Tabs} from 'antd'
import GenericTable from '../../tabs/GenericTable'
import EditProduct from './EditProduct'
import {useSimpleGetDelete} from '../../relations/utils/hooks'
import {observer} from 'mobx-react'
import IngredientsTable from '../../ingredient/components/IngredientsTable'

const ProductDetails = observer(() => {
    const {productId} = useParams<{productId: string}>()

    const {productStore} = useStores()
    const {loading, loadingDelete, currentData, onDelete} = useSimpleGetDelete(productId, productStore)

    if (loading) {
        return <FullLoader />
    }

    if (!currentData) {
        return <ErrorComponent status={404} title={i18n.t('product.errors.notFound')} />
    }

    return (
        <>
            <DetailsPageHeader
                title={currentData.name}
                onDelete={onDelete}
                messageDelete={i18n.t('product.messages.delete')}
                loadingDelete={loadingDelete}
                data={currentData}
                footer={
                    <Tabs defaultActiveKey='details'>
                        <Tabs.TabPane tab={i18n.t('tabs.details.title')} key='details'>
                            <EditProduct product={currentData} />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={i18n.t('tabs.ingredients.title')} key='ingredients'>
                            <GenericTable data={currentData.ingredients} dataTable={IngredientsTable} skipColumns={['url']} />
                        </Tabs.TabPane>
                    </Tabs>
                }
            />
        </>
    )
})

export default ProductDetails
